const getters = {
  getSickLeaves: state => state.sickLeaves,
  getSickLeave: state => state.sickLeave
}


export default getters